import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { http } from "@/lib/api";
import { TID } from "@/constants/testIds";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await http.post("/newsletter/subscribe", { email });
      if (data.status === "already_subscribed") toast.info("You're already inside the temple.");
      else toast.success("Welcome. Check your inbox for confirmation.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2 glass rounded-full pl-5 pr-2 py-2">
      <input
        data-testid={TID.newsletterEmail}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        className="flex-1 bg-transparent text-sm text-white placeholder:text-white/40 focus:outline-none"
      />
      <button
        data-testid={TID.newsletterSubmit}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-full bg-[#FF9933] text-black text-xs uppercase tracking-[0.25em] font-semibold px-4 py-2 hover:bg-[#FFD700] hover:shadow-[0_0_20px_rgba(255,153,51,0.6)] transition-all disabled:opacity-60"
      >
        {busy ? "..." : "Enter"} <ArrowRight size={14} />
      </button>
    </form>
  );
};

export default Newsletter;
